import { render } from "./CategoryTexture.vue?vue&type=template&id=9f6d5ada&scoped=true"
import script from "./CategoryTexture.vue?vue&type=script&lang=js"
export * from "./CategoryTexture.vue?vue&type=script&lang=js"

import "./CategoryTexture.vue?vue&type=style&index=0&id=9f6d5ada&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f6d5ada"]])

export default __exports__